import { render } from "./Comissoes.vue?vue&type=template&id=405552b9&scoped=true"
import script from "./Comissoes.vue?vue&type=script&lang=js"
export * from "./Comissoes.vue?vue&type=script&lang=js"

import "./Comissoes.vue?vue&type=style&index=0&id=405552b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405552b9"]])

export default __exports__